// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterDetailsConfigConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

/* List of operator group */
const OPERATOR_GROUP = {
  UNKNOWN: '...',
  BOOLEAN: 'boolean',
  COMPARISON: 'comparison',
  DATETIME: 'date&time',
  EQUIVALENCE: 'equivalence',
  FIELDCOMPARISON: 'fieldcomparison',
  STRING: 'string'
};

/* List of operator group based on data-type*/
const OPERATER_BY_DATA_TYPE = {
  numeric: [
    OPERATOR_GROUP.UNKNOWN,
    OPERATOR_GROUP.COMPARISON,
    OPERATOR_GROUP.EQUIVALENCE,
    OPERATOR_GROUP.FIELDCOMPARISON
  ],
  datetime: [
    OPERATOR_GROUP.UNKNOWN,
    OPERATOR_GROUP.COMPARISON,
    OPERATOR_GROUP.EQUIVALENCE,
    OPERATOR_GROUP.FIELDCOMPARISON,
    OPERATOR_GROUP.DATETIME
  ],
  time: [
    OPERATOR_GROUP.UNKNOWN,
    OPERATOR_GROUP.COMPARISON,
    OPERATOR_GROUP.EQUIVALENCE,
    OPERATOR_GROUP.FIELDCOMPARISON,
    OPERATOR_GROUP.DATETIME
  ],
  text: [
    OPERATOR_GROUP.UNKNOWN,
    OPERATOR_GROUP.COMPARISON,
    OPERATOR_GROUP.EQUIVALENCE,
    OPERATOR_GROUP.FIELDCOMPARISON,
    OPERATOR_GROUP.STRING
  ],
  boolean: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.EQUIVALENCE, OPERATOR_GROUP.FIELDCOMPARISON, OPERATOR_GROUP.BOOLEAN],
  money: [
    OPERATOR_GROUP.UNKNOWN,
    OPERATOR_GROUP.COMPARISON,
    OPERATOR_GROUP.EQUIVALENCE,
    OPERATOR_GROUP.FIELDCOMPARISON
  ],
  lob: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.EQUIVALENCE],
  xml: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.EQUIVALENCE],
  json: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.EQUIVALENCE],
  image: [OPERATOR_GROUP.UNKNOWN, OPERATOR_GROUP.EQUIVALENCE]
};

const DATA_TYPE = {
  NUMBER: 'Numeric',
  DATE: 'Datetime',
  TEXT: 'Text',
  MONEY: 'Money',
  TIME: 'Time'
};

export default {
  DEFAUFT_OPERATOR_GROUP: {
    numeric: OPERATOR_GROUP.EQUIVALENCE,
    datetime: OPERATOR_GROUP.DATETIME,
    text: OPERATOR_GROUP.EQUIVALENCE,
    boolean: OPERATOR_GROUP.EQUIVALENCE,
    money: OPERATOR_GROUP.EQUIVALENCE,
    time: OPERATOR_GROUP.DATETIME,
    image: OPERATOR_GROUP.EQUIVALENCE,
    lob: OPERATOR_GROUP.EQUIVALENCE,
    json: OPERATOR_GROUP.EQUIVALENCE,
    xml: OPERATOR_GROUP.EQUIVALENCE
  },

  BLANK_NULL_OPERATOR: ['image', 'lob', 'json', 'xml'],

  OPERATOR_GROUP,

  OPERATER_BY_DATA_TYPE,

  OPERATOR: {
    UNKNOWN: '...',
    BLANK: 'blank',
    NOTBLANK: 'notblank',
    NULL: 'null',
    NOTNULL: 'notnull'
  },

  /* define [sourceType] which is used to select which API is called for different group/operator (used in field-store) */
  OPERATOR_VALUE_SOURCE: {
    fieldcomparison: 'fieldSource',
    equivalence: {
      'equals(checkbox)': 'dataSource',
      'notequal(checkbox)': 'dataSource',
      'equals(popup)': 'dataSource',
      'notequal(popup)': 'dataSource',
      'equals(tree)': 'dataSourceTree',
      'notequal(tree)': 'dataSourceTree',
      'equals(manualentry)': 'dataSource',
      'equals(manualentrynoauto-complete)': 'dataSource',
      'notequal(manualentry)': 'dataSource',
      'notequal(manualentrynoauto-complete)': 'dataSource',
      'equals(selection)': 'dataSource',
      'notequal(selection)': 'dataSource'
    },
    'date&time': 'inTimePeriod'
  },

  CONSTRAINTS: {
    presence: false
  },

  CONSTRAINTS_NAME: 'value',

  REGEX: {
    DATETIMEFORMAT: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4} (0[0-9]|1[0-9]|2[0-3])\:(0[0-9]|[1-5][0-9])$/,
    NUMBER: /^-?\d+\.?\d*$/,
    INT_NUMBER: /^\d*$/,
    TIME: /^\d+$/
  },

  DATA_TYPE,

  SELECT_SETTINGS: {
    SINGLE: 'single',
    MULTIPLE: 'multiple',
    MULTIPLE_COMMA: 'multipleComma',
    MULTIPLE_NEWLINE: 'multipleNewLine',
  },
  get SELECT_TEXT() {
    return {
      get SINGLE() {
        return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_SINGLE_SELECTION');
      },
      get MULTIPLE() {
        return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_MULTIPLE_SELECTION');
      }
    };
  },
  get SELECT_MODE() {
    return {
      get SINGLE() {
        return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_LABEL_SINGLE');
      },
      get MULTIPLE() {
        return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_LABEL_MULTIPLE');
      },
      get MULTIPLE_NONE() {
        return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_LABEL_MULTIPLE_NONE');
      },
      get MULTIPLE_COMMA() {
        return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_LABEL_MULTIPLE_COMMA');
      },
      get MULTIPLE_NEW_LINE() {
        return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_LABEL_MULTIPLE_NEW_LINE');
      }
    };
  },
  DEFAUFT_VALUE: {
    ALL: '[ALL]',
    BLANK: '[BLANK]',
    NULL: '[NULL]'
  },

  get ERROR_MESSAGE_BY_DATA_TYPE() {
    return {
      Money: localizer.getText('COMMON_MESSAGES_FORMAT_NUMBER'),
      Numeric: localizer.getText('COMMON_MESSAGES_FORMAT_NUMBER'),
      Datetime: localizer.getText('COMMON_MESSAGES_FORMAT_DATE'),
      Time: localizer.getText('COMMON_MESSAGES_FORMAT_TIME')
    };
  },

  get ERROR_MESSAGE() {
    return {
      M01: localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_MESSAGE_FILTER_ALIAS_EXISTS')
    };
  },

  OPERATOR_VALUE_LIST: ['Blank', 'Not Blank', 'Null', 'Not Null', 'True', 'False'],

  OPERATOR_NAMES: ['...', 'Blank', 'Not Blank', 'Null', 'Not Null', 'True', 'False'],

  BLANK_VALUE_LIST: ['...', 'Blank', 'Not Blank', 'Null', 'Not Null'],

  get DEFAUFT_OPERATOR_LABEL() {
    return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_LABEL_EQUALS');
  },

  SHOW_MODE_OPERATOR: [
    'equals(manualentry)',
    'equals(manualentrynoauto-complete)',
    'notequal(manualentry)',
    'notequal(manualentrynoauto-complete)',
    'equals(selection)',
    'notequal(selection)'
  ],

  NO_POPULATE_IMMEDIATELY_FILTER_DATA: [
    'equals(manualentry)',
    'equals(manualentrynoauto-complete)',
    'notequal(manualentry)',
    'notequal(manualentrynoauto-complete)',
    'equals(selection)',
    'notequal(selection)',
    'equals(popup)',
    'notequal(popup)'
  ],

  SORT_TYPE: {
    ASC: 'ASC',
    DESC: 'DESC'
  },

  OPERATOR_GROUP_KEYS: {
    BOOLEAN: 'Boolean'
  },

  OPERATOR_KEYS: ['Blank', 'Not Blank', 'Null', 'Not Null'],

  EXCLUDE_FILTER_DATA_TYPE: {
    SYS_REFCURSOR: 'SYS_REFCURSOR',
    REF_CURSOR: 'REF CURSOR'
  },
  MAX_HEIGHT: 85,

  PARAM_OPERATOR_BY_DATA_TYPE: {
    Datetime: [
      'equals(date&time)',
      'equals(date)',
      'equals(manualentry)',
      'equals(manualentrynoauto-complete)',
      'equals(selection)'
    ],
    Time: [
      'equals(time)',
      'equals(manualentry)',
      'equals(manualentrynoauto-complete)',
      'equals(selection)']
  },

  HIDDEN_DATA_TYPE: ['REF CURSOR', 'SYS CURSOR'],

  DELIMITER_TYPE: {
    NEWLINE: '#$%^!#$@#'
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.FilterDetailsConfigConstants.js